import classNames from "classnames";
import "./styles.sass";
import useTranslate from "../../../hooks/useTranslate";

type LoyaltySelectedAvatarProps = {
  avatar: string | null;
  bg: "white" | "grey";
};

const LoyaltySelectedAvatar = (props: LoyaltySelectedAvatarProps) => {
  const { avatar, bg } = props;
  const t = useTranslate();

  const componentClass = classNames("LoyaltySelectedAvatar", {
    // eslint-disable-next-line camelcase
    LoyaltySelectedAvatar__white: bg === "white",
    // eslint-disable-next-line camelcase
    LoyaltySelectedAvatar__grey: bg === "grey",
  });

  return (
    <div className={componentClass}>
      <div className="LoyaltySelectedAvatar__selectedPanel">
        {t("loyalty.avatar.inner.selected")}
      </div>
      {/* {rank && ( */}
      {/*  <div className="LoyaltySelectedAvatar__rank"> */}
      {/*    <span className="LoyaltySelectedAvatar__rankTitle"> */}
      {/*      {t("loyalty.avatar.skinRank")}: */}
      {/*    </span> */}
      {/*    <div className="LoyaltySelectedAvatar__rankName">{t(rank)}</div> */}
      {/*  </div> */}
      {/* )} */}
      <div className="LoyaltySelectedAvatar__avatar">
        {avatar && <img src={avatar || undefined} alt="avatar" />}
      </div>
    </div>
  );
};

export default LoyaltySelectedAvatar;
